import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import '../../vendor/jSignature';

export default class extends Controller {
  declare padTarget: HTMLElement;

  declare inputTarget: HTMLInputElement;

  static targets = ['pad', 'input'];

  padTargetConnected(): void {
    $(this.padTarget).on('change', this.#onChange).jSignature({ 'decor-color': 'transparent' });
  }

  padTargetDisconnected(pad: HTMLElement): void {
    $(pad).off('change', this.#onChange).jSignature('destroy');
  }

  clear(): void {
    $(this.padTarget).jSignature('reset');
  }

  #onChange = (): void => {
    const bitmap = $(this.padTarget).jSignature('getData');
    const vector = $(this.padTarget).jSignature('getData', 'native');
    const isUnsigned = vector.length === 0;

    this.inputTarget.value = isUnsigned ? '' : bitmap;
    this.element.classList.toggle('is-unsigned', isUnsigned);
  };
}
